import { useMutation, useQueryClient } from 'react-query';

import { setListReadStatus as mutationFn } from 'api/endPoints/setListReadStatus';

import {
    IContext,
    IGetNotificationsResponse,
    ISetNotificationsReadStatusPayload,
} from 'components/App/AuthenticateLayout/Header/Notification/Notifications.types';

export const useMutationSetNotificationsReadStatus = () => {
    const queryClient = useQueryClient();
    return useMutation<boolean, QueryError, ISetNotificationsReadStatusPayload, IContext>(
        (params) => mutationFn(params),
        {
            meta: {
                name: 'setNotificationsReadStatus',
            },
            onMutate: async (params) => {
                // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
                await queryClient.cancelQueries('useQueryGetNotifications');

                // Snapshot the previous value
                const previous = queryClient.getQueryData<IGetNotificationsResponse[]>('useQueryGetNotifications');

                // Optimistically update to the new value
                const newData = previous ? [...previous] : [];
                newData.forEach((item) => {
                    item.isRead =
                        params.id_list.includes(item.id) || params.id_list.length === 0 ? params.read : item.isRead;
                });

                queryClient.setQueryData('useQueryGetNotifications', newData);

                // Return a context with the previous data
                return { previous };
            },
            // If the mutation fails, use the context we returned above
            onError: (err, params, context) => {
                queryClient.setQueryData('useQueryGetNotifications', context?.previous);
            },
            // Always refetch after error or success:
            onSettled: () => {
                return queryClient.invalidateQueries('useQueryGetNotifications');
            },
        },
    );
};
